export const SOUND_VOLUME = 0.35
